module.exports = __webpack_public_path__ + "static/sticky-navbar-ca5d94cf738acd794a30bffaaa1eee30.png";